<h2 mat-dialog-title>Update Note</h2>
<div mat-dialog-content>
    <p>(Members' notes are only visible to EICDataStream Users within your own organisation)</p>
    <textarea
        name="txtNote"
        [(ngModel)]="data.memberNote.note"
        rows="8"
        cols="35"
        class="form-control input-sm"
        style="width:90%;"
        [maxLength]="maxNoteLength">
    </textarea>
    <div>{{ charsLeft }} characters left</div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" [disabled]="!canSave" (click)="update()">Save</button>
</div>
